"use client"

import { createContext, useContext } from "react"

const CheckoutFrameContext = createContext<boolean>(false)

// Opts a subtree into the "framed" checkout chassis (blue page + centered white card),
// used by the standalone BNPL checkout. Absent provider => default full-bleed shell.
export const CheckoutFrameProvider = ({ children }: { children: React.ReactNode }) => <CheckoutFrameContext.Provider value>{children}</CheckoutFrameContext.Provider>

export const useFramedCheckout = (): boolean => useContext(CheckoutFrameContext)
